const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,
    LXDOMAIN = spell ? `//lingxi${spell}.xinli001.com/lingxi/service/` : `//m-lingxi${spell}.xinli001.com/lingxi/service/`,
    YIAPI = `//yiapi${spell}.xinli001.com/v5/yi/`,
    APIS = {
        // 免登陆接口
        getScalePrice: `${LXDOMAIN}notLogin/doFirstAfterBuy/getScalePrice`, // 免登+先测试后付费（for微博） 获取测评价格
        payOrder: `${LXDOMAIN}notLogin/doFirstAfterBuy/payOrder`, // 免登+先测试后付费（for微博） 支付订单
        getQrcode: `${LXDOMAIN}notLogin/doFirstAfterBuy/getQrcode`, // 免登+先测试后付费（for微博） 获取二维码
        buyActivityCard: `${LXDOMAIN}notLogin/buyActivityCard`, // 免登陆活动卡购买
        payOrderByCoupon: `${LXDOMAIN}notLogin/payOrderByCoupon`, // 解锁页支付测评并抵扣虚拟红包
        availableActivityCard: `${LXDOMAIN}activityCard/availableActivityCard`, // #获取可用活动卡信息（购买免费测评时用）
        buyActivityCardConsultCombo: `${LXDOMAIN}consult/buyActivityCardConsultCombo`, // 组合测评购买咨询（使用活动卡权益购买
        validatePhone: `${LXDOMAIN}notLogin/validatePhone`, // 投放手机号验证接口
        cepingVipBindPhone: `${LXDOMAIN}vip/v3/notLogin/bindPhone`, // 测评会员绑定手机号
        cepingVipBindPhone4: `${LXDOMAIN}vip/v4/bindPhone`, // 测评会员绑定手机号
        cepingVipBindTfPhone4: `${LXDOMAIN}vip/v4/tf/receiveVip`, // 测评投放会员绑定手机号
        searchOrderDoAfterBuyNew: `${LXDOMAIN}notLogin/searchOrderDoAfterBuyNew`, // 订单查询接口
        existOrder: `${LXDOMAIN}notLogin/existOrder`, // 查询用户是否存在订单
        splitFlowType: `${LXDOMAIN}notLogin/splitFlowType`, // 获取投放分流类型
        payMbtiOrder: `${LXDOMAIN}notLogin/doFirstAfterBuy/payMbtiOrder`, // 先测试后付费 MBTI多题版本 解锁支付订单接口
        payDepressedOrder: `${LXDOMAIN}notLogin/doFirstAfterBuy/payDepressedOrder`, // 先测试后付费解锁支付抑郁订单
    }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/notLogin.js